import _get from 'lodash/get';

import { Base, Address } from '@/models';
import { toCamelCase } from '@/utilities';

export class Contact extends Base {

  public name: string;
  public address: Address;
  public phone: string;
  public email: string;

  /**
   * Constructor initialises the variables from the class Contact
   * @param data - the data to construct a type with all properties of <Contact>
   */
  public constructor(data?: Partial<Contact>) {
    super(data);
    data = toCamelCase(data);

    this.name = _get(data, 'name', '');
    this.address = new Address(_get(data, 'address'));
    this.phone = _get(data, 'phone', '');
    this.email = _get(data, 'email', '');
  }

}
